<template>
  <tooltip
    :content="$t('db.recipient.not_allow_select')"
    theme="light"
    :transfer="true"
    class="ml-3"
    placement="top"
    min-width="200"
    max-width="200"
    :disabled="recipients_count"
  >
    <div
      :class="{
        'disabled-block': disable_icon
      }"
      @click="disable_icon ? $event.preventDefault() : $emit('click', !value)"
    >
      <icon v-if="value" :size="size" type="md-checkmark" :color="green" />

      <icon v-if="!value" :size="size" type="md-add" :color="blue" />
    </div>
  </tooltip>
</template>

<script>
  import { green, blue } from '@shared/helpers/css';

  export default {
    props: {
      size: {
        type: [String, Number],
        default: 20
      },

      value: {
        type: Boolean,
        default: false
      },

      recipients_count: {
        type: Number,
        default: 1
      }
    },

    data() {
      return {
        green,
        blue
      };
    },

    computed: {
      disable_icon() {
        return this.recipients_count === 0;
      }
    },
  };
</script>

<style lang="scss" scoped>
  .ivu-icon:hover {
    cursor: pointer;
  }
</style>
